






















import { Component, Vue, Prop, Emit } from "vue-property-decorator";
@Component
export default class CellRadio extends Vue {
    @Prop(Array) private radios !: object[];
    @Prop() private value ?: any;

    private valSelected: any = '';
    private created() {
        this.valSelected = this.value;
    }

    @Emit('change')
    private onChange() {
        return this.valSelected;
    }
}
